import type { SourceDocument } from "../../../api/content/sourcesApi";

/** A document as people know it: its title, if the import gave one, else its key (such as `V12/0003`). */
export function documentDisplayName(document: Pick<SourceDocument, "key" | "metadata">): string {
  return document.metadata["title"]?.trim() || document.key;
}

/**
 * A segment path as people read it, the one name of a part of a text everywhere (P-E):
 * `petition.1` is "Petition 1", `subentry.2/sentence.1` is "Subentry 2, sentence 1", `head`
 * is "Head". The path itself stays the reference.
 */
export function segmentDisplayName(segmentPath: string): string {
  const name = segmentPath
    .split("/")
    .map((step) => step.replace(/[._]/g, " ").trim())
    .filter((step) => step !== "")
    .join(", ");
  return name.charAt(0).toUpperCase() + name.slice(1);
}
